import { Component, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-individual-alert-modal',
  templateUrl: './individual-alert-modal.html',
  styleUrls: ['./individual-alert-modal.scss']
})
export class IndividualAlertModalComponent implements OnInit {

  authoringContentData: any;
  constructor(public manageLineService: ManageLineService, public utilsSvc: UtilsService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().changeNumberAuthoring;
  }
  overrideChanges() {
    this.manageLineService.notifyChangeNumberFlow.next({ id: 'overrideChanges' });
    this.activeModal.dismiss('Cross click');
  }
  discardChanges() {
    this.manageLineService.notifyChangeNumberFlow.next({ id: 'discardChanges' });
    this.activeModal.dismiss('Cross click');
  }
}
